import { useGetMyProfile } from 'services/hooks/user';
import { useGetBankAccountVerifications, useGetUsersIdentityVerifications } from 'services/hooks/verification';

export function useCheckBankAccountVerificationsEnable() {
  const { data: profileData } = useGetMyProfile();
  const { data: identityData } = useGetUsersIdentityVerifications(profileData?.id);
  const isEmailVerificationCompleted = profileData?.verified ?? false;
  const isIdentityVerificationCompleted = Boolean(identityData);
  const { data: bankAccountData } = useGetBankAccountVerifications(profileData?.id);

  const isBankAccountVerificationEnabled =
    (isEmailVerificationCompleted && isIdentityVerificationCompleted) || bankAccountData?.status === 'verified';
  return isBankAccountVerificationEnabled;
}
